export async function useNewsletterSubscribe(email: string, firstName: string|undefined): Promise<any> {
  return await $fetch('https://us-central1-smoxy-app.cloudfunctions.net/api/newsletter/subscribe', {
    method: 'POST',
    params: { 'email': email, 'firstName': firstName },
  }).catch(e => e.data);
}